export default "__VITE_ASSET__DgO9lJ3y__"